module.exports = __webpack_public_path__ + "static/media/mode-35.e4683f6e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-35.svg
// module id = 990
// module chunks = 2